<template>
  <div :class="['recommend-list', `${navKey}-list`]">
    <template v-if="useMobileUI">
      <div class="card-list">
        <component :is="navKey" :list="list"></component>
      </div>
      <!--<loading-complete v-if="list.length < 4" />-->
    </template>
    <div v-else class="recommend-list-container">
      <div
        v-stlog="{ goRecommendDetail: item }"
        v-for="(item, index) in list"
        class="recommend-article"
        :key="index"
      >
        <div class="recommend-article-left">
          <div
            class="recommend-article-title ellipsis"
            @click="jumpToDetail(item)"
          >
            {{ item.title }}
          </div>
          <div class="recommend-article-info">
            <span class="recommend-article-author-name ellipsis">{{ item.user.nickname }}</span>
            <heat-degree :value="item.readCnt" />
          </div>
        </div>
        <div class="recommend-article-right" @click="jumpToDetail(item)">
          <image-clip :src="item.previewUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageClip from '@/components/common/ImageClip';
import HeatDegree from '@/components/common/HeatDegree';
import LoadingComplete from '@/components/common/LoadingComplete';

import Tongren from '@/components/List/FanList';
import Shipin from '@/components/List/VideoList';
import Zhuanlan from '@/components/List/TopicList';
import Huodong from '@/components/List/ActionList';
import Ziyuan from '@/components/List/ResourceList';
import Gonglue from '@/components/List/StrategyList';

export default {
  name: 'RecommendList',
  components: {
    ImageClip,
    HeatDegree,
    LoadingComplete,

    Shipin,
    Ziyuan,
    Gonglue,
    Huodong,
    Tongren,
    Zhuanlan
  },
  props: {
    list: {
      type: Array
    }
  },
  computed: {
    navKey() {
      return this.$route.params.navKey;
    }
  },
  methods: {
    jumpToDetail(item) {
      const { navKey, boardKey } = this.$route.params;

      this.openRouterByBlank({
        name: 'BoardDetail',
        params: {
          navKey,
          boardKey,
          cardNo: item.cardNo
        },
        query: {
          communityNo: item.communityNo
        }
      });
    }
  }
};
</script>

<style lang="less">
.recommend-article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  & + & {
    margin-top: 20px;
  }
  &-left {
    width: 182px;
  }
  &-right {
    width: 94px;
    height: 64px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    height: 20px;
    cursor: pointer;
    font-size: @font-14;
    color: @text-color-primary;
    line-height: @line-height-12;
    font-weight: @font-weight-normal;
    &:hover {
      color: @blue-primary;
    }
  }
  &-info {
    display: flex;
    margin-top: 4px;
    align-items: center;
    justify-content: space-between;
  }
  &-author-name {
    width: 120px;
    font-size: @font-12;
    color: @text-color-secondary;
    line-height: @line-height-12;
  }
}
</style>
